(function () {
  'use strict';

  var countTimer = null;

  window.SwymWishlistHelpers = {
    getShopOrigin: function () {
      var config = window.SwymWishlistConfig || {};
      return config.shopOrigin || window.location.origin;
    },

    toProductPath: function (url) {
      if (!url) return '';
      var clean = String(url).split('?')[0].split('#')[0];
      if (clean.indexOf('http') === 0) {
        try {
          return new URL(clean).pathname;
        } catch (error) {
          var match = clean.match(/\/products\/[^/?#]+/);
          return match ? match[0] : clean;
        }
      }
      return clean.charAt(0) === '/' ? clean : '/' + clean;
    },

    toAbsoluteDu: function (url) {
      if (!url) return '';
      var clean = String(url).split('?')[0].split('#')[0];
      if (clean.indexOf('http') === 0) return clean;
      return this.getShopOrigin() + this.toProductPath(clean);
    },

    getDefaultVariant: function (variants) {
      if (!variants || !variants.length) return null;

      var available = variants.find(function (variant) {
        return variant.available !== false && variant.stk !== 0 && variant.stk !== '0';
      });

      return available || variants[0];
    },

    buildFromProductJson: function (productJson, productPath, canonicalUrl) {
      var empi = Number(productJson.empi || productJson.id);
      var variants = productJson.variants || [];
      var variant = this.getDefaultVariant(variants);

      if (!empi || !variant) return null;

      var epi = Number(variant.epi || variant.id);
      if (!epi || epi === empi) return null;

      return {
        empi: empi,
        epi: epi,
        du: this.toAbsoluteDu(canonicalUrl || productJson.du || productPath),
        dt: productJson.dt || productJson.title || '',
        iu: variant.iu || productJson.iu || '',
        pr: variant.pr != null ? variant.pr : variant.price != null ? variant.price : productJson.pr || 0,
      };
    },

    getProductLevelEpi: function (pageData) {
      var variants = window.SwymProductVariants;

      if (variants && typeof variants === 'object') {
        var variantList = Object.keys(variants).map(function (key) {
          return variants[key];
        });

        if (variantList.length) {
          var available = variantList.find(function (variant) {
            return variant.stk !== 0 && variant.stk !== '0' && variant.stk !== false;
          });
          var chosen = available || variantList[0];

          if (chosen) {
            return Number(chosen.epi || chosen.id);
          }
        }
      }

      return Number(pageData && pageData.epi);
    },

    buildFromPageData: function (pageData) {
      if (!pageData || pageData.et !== 1) return null;

      var epi = this.getProductLevelEpi(pageData);
      if (!pageData.empi || !epi || epi === Number(pageData.empi)) return null;

      return {
        empi: Number(pageData.empi),
        epi: epi,
        du: this.toAbsoluteDu(pageData.du),
        dt: pageData.dt || '',
        iu: pageData.iu || '',
        pr: pageData.pr || 0,
      };
    },

    getWishlistSource: function (btn) {
      if (btn && btn.closest('product-recommendations, .product-recommendations, .compact-product-recommendations')) {
        return 'recommendations';
      }

      if (btn && btn.closest('.predictive-search, .predictive-search-results')) {
        return 'search-results';
      }

      if (
        document.body.classList.contains('template-collection') ||
        (btn && btn.closest('.collection-wrapper, results-list'))
      ) {
        return 'collections-grid';
      }

      return 'featured-grid';
    },

    withSource: function (product, source) {
      return Object.assign({}, product, { source: source });
    },

    resolveProduct: function (swat, opts, callback) {
      var helpers = this;
      var productPath =
        opts.productPath ||
        (opts.productUrl && helpers.toProductPath(opts.productUrl)) ||
        (opts.handle ? '/products/' + opts.handle : '');

      if (!productPath) return;

      swat.getProductDetails({ du: productPath }, function (productJson) {
        callback(
          helpers.buildFromProductJson(productJson, productPath, opts.productUrl || opts.canonicalUrl)
        );
      });
    },

    isProductWishlisted: function (wishlisted, empi) {
      return wishlisted.some(function (item) {
        return Number(item.empi) === Number(empi);
      });
    },

    findWishlistedProduct: function (wishlisted, empi) {
      return (
        wishlisted.find(function (item) {
          return Number(item.empi) === Number(empi);
        }) || null
      );
    },

    removeProduct: function (swat, empi, onSuccess, onError, source) {
      swat.fetch(function (wishlisted) {
        var item = window.SwymWishlistHelpers.findWishlistedProduct(wishlisted, empi);
        if (!item) {
          if (onError) onError();
          return;
        }

        swat.removeFromWishList(
          window.SwymWishlistHelpers.withSource(
            {
              epi: item.epi,
              empi: item.empi,
              du: item.du,
              dt: item.dt,
              iu: item.iu,
              pr: item.pr,
            },
            source || 'pdp'
          ),
          onSuccess,
          onError
        );
      });
    },

    setHeaderCount: function (count) {
      var countEl = document.getElementById('swym-header-count');
      if (!countEl) return;

      countEl.textContent = count;
      countEl.style.display = count > 0 ? '' : 'none';
    },

    countUniqueProducts: function (products) {
      var unique = {};

      (products || []).forEach(function (item) {
        unique[Number(item.empi)] = true;
      });

      return Object.keys(unique).length;
    },

    updateHeaderCount: function (swat) {
      swat.fetch(function (products) {
        window.SwymWishlistHelpers.setHeaderCount(
          window.SwymWishlistHelpers.countUniqueProducts(products)
        );
      });
    },

    notifyChange: function (swat, delta) {
      if (delta) {
        var countEl = document.getElementById('swym-header-count');
        if (countEl) {
          var nextCount = Math.max(0, (Number(countEl.textContent) || 0) + delta);
          this.setHeaderCount(nextCount);
        }
      }

      if (!swat) return;

      clearTimeout(countTimer);
      countTimer = setTimeout(function () {
        window.SwymWishlistHelpers.updateHeaderCount(swat);
      }, 400);
    },
  };

  // Swym injects carousel containers with parent ARIA roles (e.g. listbox/list)
  // without the required child roles. Strip those until Swym fixes it upstream.
  var SWYM_PARENT_ROLES = {
    listbox: '[role="option"]',
    list: '[role="listitem"], li',
    tablist: '[role="tab"]',
    menu: '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]',
    menubar: '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]',
    radiogroup: '[role="radio"]',
    tree: '[role="treeitem"]',
    grid: '[role="row"]',
    rowgroup: '[role="row"]',
  };

  function fixSwymAriaRoles(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll
      ? scope.querySelectorAll('[id^="swym-storefront-layout"][role], [class*="swym-storefront-layout"][role]')
      : [];

    if (root instanceof Element && root.matches && root.matches('[id^="swym-storefront-layout"][role], [class*="swym-storefront-layout"][role]')) {
      nodes = [root].concat(Array.prototype.slice.call(nodes));
    }

    Array.prototype.forEach.call(nodes, function (el) {
      var role = (el.getAttribute('role') || '').toLowerCase();
      var childSelector = SWYM_PARENT_ROLES[role];
      if (!childSelector) return;
      if (!el.querySelector(childSelector)) {
        el.removeAttribute('role');
      }
    });
  }

  function observeSwymAriaRoles() {
    fixSwymAriaRoles(document);

    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.target instanceof Element) {
          fixSwymAriaRoles(mutation.target);
        }
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node.nodeType === 1) fixSwymAriaRoles(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['role'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSwymAriaRoles);
  } else {
    observeSwymAriaRoles();
  }
})();
